// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"39fc0945","95":"80b54244","131":"f4ee9e4f","191":"5f20db51","426":"7ebceea6","459":"d9524b50","491":"ce50ae45"}[chunkId] + ".chunk.js";
};